/**
 * Vertical stack container for dev-only map debug pills (bottom-right).
 */

import type { ReactNode } from "react";
import React from "react";
import {
    MAP_DEV_DEBUG_STACK_BOTTOM_CLASS,
    MAP_DEV_DEBUG_STACK_GAP_PX,
    MAP_DEV_DEBUG_STACK_Z_INDEX,
} from "./mapDevDebugStack.configuration";

export interface MapDevDebugPillStackProps {

    /** Stack content: overlays and pills in top-to-bottom DOM order. */
    "children": ReactNode;

    /** Enables dark palette variants when true. */
    "isDarkUi": boolean;
}

/**
 * Anchors dev debug pills in a single column above map attribution.
 * Add a child pill to extend the stack — no per-button `bottom-*` offsets.
 *
 * @param props Children and theme flag.
 * @returns Positioned flex column wrapper.
 */
const MapDevDebugPillStack: React.FC<MapDevDebugPillStackProps> = ( { children } ) => {
    return (
        <div
            className={`absolute right-2 flex flex-col items-end ${ MAP_DEV_DEBUG_STACK_BOTTOM_CLASS }`}
            style={{
                "gap":    `${ MAP_DEV_DEBUG_STACK_GAP_PX }px`,
                "zIndex": MAP_DEV_DEBUG_STACK_Z_INDEX,
            }}
        >
            {children}
        </div>
    );
};

export default MapDevDebugPillStack;
